import "../../../styles/dragAndDrop.scss";

import Icon, { iconTypes } from "./Icon";
import React, { Component } from "react";


import {Localization} from "../../common/util/localization.jsx";
import PropTypes from "prop-types";

class DragAndDrop extends Component {
    constructor(props){
        super(props);
        this.state = {
            drag: false,
        };

        this.whiteList = ["jpg", "jpeg", "png", "gif", "bmp", "tga", "pdf", "txt", "doc", "dot", "wkb", "docx", "docm", "dotx", "dotm", "docb", "xls", "xt", "xml", "xlm", "xlsx", "xltx", "xltm", "xlsb", "xla", "xlam", "xll", "xlw", "ppt", "pptx", "pot", "pps", "pub", "xps", "odt", "ott", "odm", "html", "oth", "ods", "ots", "odg", "otg", "odp", "otp", "odf", "odb", "oxt", "odx", "wps", "rtf", "csv", "psw"];
        
        if (props.allowVideo)
        {
            this.whiteList =  this.whiteList.concat(["mpg", "mpeg","wmv", "mp4", "mov","avi" ]);
        }

        this.AcceptWhiteList = `.${this.whiteList[0]}`;
        for(let i=1; i<this.whiteList.length; i++){
            this.AcceptWhiteList += `,.${this.whiteList[i]}`;
        }

        this.dropRef = React.createRef();
        this.dragCounter = 0;

        this.filterFiles = this.filterFiles.bind(this);

        this.handleDrag = this.handleDrag.bind(this);
        this.handleDragIn = this.handleDragIn.bind(this);
        this.handleDragOut = this.handleDragOut.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
        this.onClickFileUpload = this.onClickFileUpload.bind(this);
    }

    componentDidMount() {
        const div = this.dropRef.current;
        div.addEventListener("dragenter", this.handleDragIn);
        div.addEventListener("dragleave", this.handleDragOut);
        div.addEventListener("dragover", this.handleDrag);
        div.addEventListener("drop", this.handleDrop);
    }
    componentWillUnmount() {
        const div = this.dropRef.current;
        div.removeEventListener("dragenter", this.handleDragIn);
        div.removeEventListener("dragleave", this.handleDragOut);
        div.removeEventListener("dragover", this.handleDrag);
        div.removeEventListener("drop", this.handleDrop);
    }

    filterFiles(files){
        const maxFileSize = 50000000;//50MB
        const ret = [];
        let error = "";
        for(let i=0; i<files.length; i++){
            const ext = files[i].name.split(".").pop().toLowerCase();
            if( !this.whiteList.includes(ext) ){
                error = `Utillat filtype ${ext}`;
            }
            else if(files[i].size>=maxFileSize) {
                error = `Vedlegg må ikke være større enn ${maxFileSize/1000000} Mb`;
            }
            else
            {
                ret.push(files[i]);
            }
        }
        return {files: ret, error: error};
    }

    handleDrag(e) {
        e.preventDefault();
        e.stopPropagation();
    }
    handleDragIn(e) {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter++;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            this.setState({drag: true});
        }
    }
    handleDragOut(e) {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter--;
        if (this.dragCounter === 0) {
            this.setState({drag: false});
        }
    }
    handleDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({drag: false});
        const filteredFiles = this.filterFiles(e.dataTransfer.files);

        if (filteredFiles.error)
        {
            this.props.handleError(filteredFiles.error);
        }

        if (filteredFiles.files && filteredFiles.files.length > 0) {
            this.props.handleFiles(filteredFiles.files);
            e.dataTransfer.clearData();
            this.dragCounter = 0;
        }
    }
    onClickFileUpload(e) {
        e.preventDefault();
        e.stopPropagation();
        const filteredFiles = this.filterFiles(e.target.files);

        if (filteredFiles.error)
        {
            this.props.handleError(filteredFiles.error);
        }

        if (filteredFiles.files && filteredFiles.files.length > 0) {
            this.props.handleFiles(filteredFiles.files);
        }
    }

    render() {
        const {
            disabled,
            localization,
            allowVideo,
        } = this.props;
        return (
            <div className={this.state.drag?"drop-area-hover":"drop-area"} style={{opacity:disabled?0.5:1.0}} ref={this.dropRef} >
                <div className="drop-area-info">
                    <div className="text">
                        <div>{localization.text("help", allowVideo ? "dropAreaInfo1Video" : "dropAreaInfo1")}</div>
                        <div>
                            {localization.text("help", "dropAreaInfo2.1")}
                            <b> {localization.text("help","dropAreaInfo2.2")}</b>
                            {localization.text("help","dropAreaInfo2.3")}
                        </div>
                    </div>
                    <label htmlFor="contained-button-file">
                        <div className="btn icon" >
                            <Icon type={iconTypes.upload} />
                            {localization.text("help","upload")}
                        </div>
                    </label>
                    <input accept={this.AcceptWhiteList} id="contained-button-file" style={{display:"none"}} multiple type="file" onChange={this.onClickFileUpload} disabled={disabled}/>
                </div>
            </div>
        );
    }
}

DragAndDrop.propTypes = {
    localization: Localization.propTypes.isRequired,
    handleFiles: PropTypes.func.isRequired,
    handleError: PropTypes.func.isRequired,    
    disabled: PropTypes.bool.isRequired,
    allowVideo: PropTypes.bool.isRequired,
};

export default DragAndDrop;